module.exports = "<span class=\"text text__small text__main\">{{ text }}</span>\r\n"